import MessageTip from './MessageTip';

export default MessageTip;